module.exports = __webpack_public_path__ + "static/img/STEVE_WAUGH.eec90f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/STEVE_WAUGH.jpg
// module id = YmyR
// module chunks = 0